import type { SyncExternalBranchJobStatus } from '../enums/SyncExternalBranchJobStatus'

export class ExternalBranchJobFilterEntity {
  externalBranchId?: number
  status?: SyncExternalBranchJobStatus
  date?: Date[]
  page?: number
  limit?: number
}
